// Auto-generated per-query builders for Workspace
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { WorkspaceReadAPI, WorkspaceWriteAPI, WorkspaceReadAPISchema, WorkspaceWriteAPISchema } from '../types/workspace';
import { ModelRegistry } from '../../registries/model-registry';
import { BelongsToWorkspace, ContainsPackage, GroupAt, HasProduct, HasRFLPProject, HasThreads, Owns, ParentScope } from '../../relationships/relationship';

import { Task } from '../../tasks/api/task';
import { Organisation } from './organisation';
import { PDMProduct } from '../../pdm/api/pdmproduct';
import { Project } from '../../rflp/api/project';
import { SecurityScope } from '../../shared/api/securityscope';
import { Group } from './group';
import { Thread } from '../../chat/api/thread';
import { MBSE_Package } from '../../mbse/api/mbse_package';



// Field names for order_by on Task
type TaskFields = "name" | "-name" | "started_at" | "-started_at" | "status" | "-status";

// Field names for order_by on Workspace
type WorkspaceFields = "created_at" | "-created_at" | "name" | "-name";


// Include spec for query: BaseAllWorkspacesIncludeSpec
export interface BaseAllWorkspacesIncludeSpec {
  owner_org?: {
  };
}

// Include spec for query: TasksWorkspaceTasksIncludeSpec
export interface TasksWorkspaceTasksIncludeSpec {
  thread?: {
  };
  currently_attached_to?: {
  };
}

// Include spec for query: PdmTasksWorkspaceWithProductsIncludeSpec
export interface PdmTasksWorkspaceWithProductsIncludeSpec {
  products?: {
    _order_by?: ("created_at" | "name")[];
  };
  rflp_projects?: {
    _order_by?: ("created_at" | "name")[];
  };
}


// Builder chain for query: base-all-workspaces

export interface BaseAllWorkspacesBuilder_0 {
  orderBy(field?: WorkspaceFields): BaseAllWorkspacesBuilder_0;
}

export interface BaseAllWorkspacesBuilder_0 {
  limit(value?: number): BaseAllWorkspacesBuilder_0;
  load(include: BaseAllWorkspacesIncludeSpec): BaseAllWorkspacesBuilder_0;
  all(): Promise<Workspace[]>;
  first(): Promise<Workspace | null>;
  get(): Promise<Workspace[]>;
  execute(): Promise<Workspace[]>;
}

// Builder chain for query: tasks-workspace-tasks

export interface TasksWorkspaceTasksBuilder_0 {
  tasks: TasksWorkspaceTasksBuilder_1;
}

export interface TasksWorkspaceTasksBuilder_1 {
  filter(conditions: { __type?: any }): TasksWorkspaceTasksBuilder_1;
}

export interface TasksWorkspaceTasksBuilder_1 {
  orderBy(field?: TaskFields): TasksWorkspaceTasksBuilder_1;
}

export interface TasksWorkspaceTasksBuilder_1 {
  limit(value?: number): TasksWorkspaceTasksBuilder_1;
  load(include: TasksWorkspaceTasksIncludeSpec): TasksWorkspaceTasksBuilder_1;
  all(): Promise<Task[]>;
  first(): Promise<Task | null>;
  get(): Promise<Task[]>;
  execute(): Promise<Task[]>;
}

// Builder chain for query: pdm_tasks-workspace-with-products

export interface PdmTasksWorkspaceWithProductsBuilder_0 {
  load(include: PdmTasksWorkspaceWithProductsIncludeSpec): PdmTasksWorkspaceWithProductsBuilder_0;
  all(): Promise<Workspace[]>;
  first(): Promise<Workspace | null>;
  get(): Promise<Workspace[]>;
  execute(): Promise<Workspace[]>;
}


// Union of all query entry points
export type WorkspaceQueryBuilder = BaseAllWorkspacesBuilder_0 | TasksWorkspaceTasksBuilder_0 | PdmTasksWorkspaceWithProductsBuilder_0;

// Available query names for .setQuery()
export type WorkspaceQueryNames = "base-all-workspaces" | "tasks-workspace-tasks" | "pdm_tasks-workspace-with-products";

// Type narrowing for .setQuery()
export type WorkspaceBuilderForQuery<Q extends WorkspaceQueryNames> =
  Q extends "base-all-workspaces" ? BaseAllWorkspacesBuilder_0
  : Q extends "tasks-workspace-tasks" ? TasksWorkspaceTasksBuilder_0
  : Q extends "pdm_tasks-workspace-with-products" ? PdmTasksWorkspaceWithProductsBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type WorkspaceInstanceQueryResult<Q extends WorkspaceQueryNames> =
  Q extends "base-all-workspaces" ? BaseAllWorkspacesBuilder_0
  : Q extends "tasks-workspace-tasks" ? TasksWorkspaceTasksBuilder_0
  : Q extends "pdm_tasks-workspace-with-products" ? PdmTasksWorkspaceWithProductsBuilder_0
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  'order_by|limit': 'base-all-workspaces',
  'tasks|filter|order_by|limit': 'tasks-workspace-tasks',
  '': 'pdm_tasks-workspace-with-products',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends WorkspaceQueryNames>(queryName: Q): WorkspaceBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}

Object.defineProperty(QueryBuilderImpl.prototype, 'tasks', {
  get() {
    return new QueryBuilderImpl('Task', [...this.path, 'tasks'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});

export interface Workspace extends Partial<WorkspaceReadAPI> {}
export class Workspace extends NeoNodeBase<WorkspaceReadAPI, WorkspaceWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Workspace";
  static readonly readSchema = WorkspaceReadAPISchema;
  static readonly writeSchema = WorkspaceWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    parent_scope: { target: "SecurityScope", cardinality: "one", isParent: false, relClass: "ParentScope", direction: "out" },
    child_scopes: { target: "SecurityScope", cardinality: "many", isParent: false, relClass: "ParentScope", direction: "in" },
    groups: { target: "Group", cardinality: "many", isParent: false, relClass: "GroupAt", direction: "in" },
    owner_org: { target: "Organisation", cardinality: "one", isParent: true, relClass: "Owns", direction: "in" },
    tasks: { target: "Task", cardinality: "many", isParent: false, relClass: "BelongsToWorkspace", direction: "in" },
    threads: { target: "Thread", cardinality: "many", isParent: false, relClass: "HasThreads", direction: "out" },
    products: { target: "PDMProduct", cardinality: "many", isParent: false, relClass: "HasProduct", direction: "out" },
    packages: { target: "MBSE_Package", cardinality: "many", isParent: false, relClass: "ContainsPackage", direction: "out" },
    rflp_projects: { target: "Project", cardinality: "many", isParent: false, relClass: "HasRFLPProject", direction: "out" },
  };

  protected get modelName(): string {
    return 'Workspace';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Workspace.label;
  }


  constructor(data: Partial<WorkspaceWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: WorkspaceReadAPI, loadContext?: Record<string, any>): Workspace {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { groups, parent_scope, child_scopes, owner_org, tasks, threads, products, packages, rflp_projects, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = WorkspaceReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, groups: groups, parent_scope: parent_scope, child_scopes: child_scopes, owner_org: owner_org, tasks: tasks, threads: threads, products: products, packages: packages, rflp_projects: rflp_projects };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Workspace.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'groups', 'Group', ModelRegistry);
    loadOneRelationship(processed, 'parent_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'child_scopes', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'owner_org', 'Organisation', ModelRegistry);
    loadManyRelationship(processed, 'tasks', 'Task', ModelRegistry);
    loadManyRelationship(processed, 'threads', 'Thread', ModelRegistry);
    loadManyRelationship(processed, 'products', 'PDMProduct', ModelRegistry);
    loadManyRelationship(processed, 'packages', 'MBSE_Package', ModelRegistry);
    loadManyRelationship(processed, 'rflp_projects', 'Project', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Workspace(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): WorkspaceQueryBuilder {
    return new QueryBuilderImpl('Workspace').filter(conditions) as any;
  }

  static all(): WorkspaceQueryBuilder {
    return new QueryBuilderImpl('Workspace') as any;
  }

  static async first(): Promise<Workspace | null> {
    const results = await new QueryBuilderImpl('Workspace').execute();
    return results[0] || null;
  }


  static setQuery<Q extends WorkspaceQueryNames>(queryName: Q): WorkspaceBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Workspace');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends WorkspaceQueryNames>(queryName: Q): WorkspaceInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Workspace.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'owner_org' - Python ORM style (cached)
  get owner_org(): RelationshipManager<this, Organisation> {
    return this.getOrCreateRelationshipManager('owner_org', () => {
      return new RelationshipManager(this, 'owner_org', 'one', Owns as typeof Relationship);
    });
  }

  // Relationship manager for 'products' - Python ORM style (cached)
  get products(): RelationshipManager<this, PDMProduct> {
    return this.getOrCreateRelationshipManager('products', () => {
      return new RelationshipManager(this, 'products', 'many', HasProduct as typeof Relationship);
    });
  }

  // Relationship manager for 'rflp_projects' - Python ORM style (cached)
  get rflp_projects(): RelationshipManager<this, Project> {
    return this.getOrCreateRelationshipManager('rflp_projects', () => {
      return new RelationshipManager(this, 'rflp_projects', 'many', HasRFLPProject as typeof Relationship);
    });
  }

  // Relationship manager for 'parent_scope' - Python ORM style (cached)
  get parent_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('parent_scope', () => {
      return new RelationshipManager(this, 'parent_scope', 'one', ParentScope as typeof Relationship);
    });
  }

  // Relationship manager for 'child_scopes' - Python ORM style (cached)
  get child_scopes(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('child_scopes', () => {
      return new RelationshipManager(this, 'child_scopes', 'many', ParentScope as typeof Relationship);
    });
  }

  // Relationship manager for 'groups' - Python ORM style (cached)
  get groups(): RelationshipManager<this, Group> {
    return this.getOrCreateRelationshipManager('groups', () => {
      return new RelationshipManager(this, 'groups', 'many', GroupAt as typeof Relationship);
    });
  }

  // Relationship manager for 'tasks' - Python ORM style (cached)
  get tasks(): RelationshipManager<this, Task> {
    return this.getOrCreateRelationshipManager('tasks', () => {
      return new RelationshipManager(this, 'tasks', 'many', BelongsToWorkspace as typeof Relationship);
    });
  }

  // Relationship manager for 'threads' - Python ORM style (cached)
  get threads(): RelationshipManager<this, Thread> {
    return this.getOrCreateRelationshipManager('threads', () => {
      return new RelationshipManager(this, 'threads', 'many', HasThreads as typeof Relationship);
    });
  }

  // Relationship manager for 'packages' - Python ORM style (cached)
  get packages(): RelationshipManager<this, MBSE_Package> {
    return this.getOrCreateRelationshipManager('packages', () => {
      return new RelationshipManager(this, 'packages', 'many', ContainsPackage as typeof Relationship);
    });
  }

}
